import React from "react";
import { Outlet } from "react-router-dom";

const TenantManagementParentPage = () => {
  return <Outlet />;
};

export default TenantManagementParentPage;
